import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Rtipopservice {
  private showPopupSource = new Subject<any>();
  showPopup$ = this.showPopupSource.asObservable();

  show() {
    this.showPopupSource.next(true);
    
  }
}
